import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcContextVisibility = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M17 3.5a1.5 1.5 0 0 1 3 0v8.68a8.94 8.94 0 0 0-3-1.062V3.5Zm-2 7.516V8a1.5 1.5 0 0 0-3 0v3.723a8.948 8.948 0 0 1 3-.707Zm-5 1.891V5.5a1.5 1.5 0 1 0-3 0v11.63l.132-.345A9.025 9.025 0 0 1 10 12.907ZM3.5 9A1.5 1.5 0 0 0 2 10.5v7a1.5 1.5 0 0 0 3 0v-7A1.5 1.5 0 0 0 3.5 9Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M16.04 16.25a1.25 1.25 0 0 1-2.196.818 1.75 1.75 0 1 0 2.113-1.267c.054.14.083.291.083.45Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M9 17.5a7.003 7.003 0 0 1 13.08 0A7.002 7.002 0 0 1 9 17.5Zm3.29 0a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcContextVisibility");

export { IcContextVisibility };
//# sourceMappingURL=ic-context-visibility.js.map
